export default "__VITE_ASSET__CCsKsuQB__"